webpackJsonp([151129064198652],{

/***/ 1384:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ClientRdvmInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"clientId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"contactIds","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"isPreferred","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"notes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"rdvmId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-client-rdvm-input-29d8465b4d222f63034d.js